module.exports = __webpack_public_path__ + "static/media/dragons-silhouette.7582ffb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/dragons-silhouette.svg
// module id = 1327
// module chunks = 0